import { autoMount } from '../../../utils/autoMount';
import { TvShow } from '../../../components/pages/tvShow';

autoMount({ TvShow });
